import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="headers" id="headers"></a>
    <h1 {...{
      "id": "windowsheaders"
    }}>{`windows.Headers`}</h1>
    <p>{`Headers class represents HTTP request and response headers.`}</p>
    <p><strong parentName="p">{`Since`}</strong>{`: v7.3.0  `}</p>
    <a name="new-headers-new" id="new-headers-new"></a>
    <h2 {...{
      "id": "headersinit"
    }}>{`Headers(`}{`[init]`}{`)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[init]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Headers`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Array<{string, string}>`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An existing Headers object, an array of name-value pairs or object literal with string values.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="headers-append" id="headers-append"></a>
    <h2 {...{
      "id": "appendname-value"
    }}>{`append(name, value)`}</h2>
    <p>{`Appends a new value onto an existing header inside a Header object, or add the header if it does not exist.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Headers/append"
      }}>{`Headers - append`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of the HTTP header`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Value of the HTTP header`}</td>
        </tr>
      </tbody>
    </table>
    <a name="headers-delete" id="headers-delete"></a>
    <h2 {...{
      "id": "deletename"
    }}>{`delete(name)`}</h2>
    <p>{`Deletes a header from the current Header object.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Headers/delete"
      }}>{`Headers - delete`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of the HTTP header`}</td>
        </tr>
      </tbody>
    </table>
    <a name="headers-get" id="headers-get"></a>
    <h2 {...{
      "id": "getname"
    }}>{`get(name)`}</h2>
    <p>{`Returns a byte string of all the values of a header within the Headers object with given name.
If the requested header does not exist in the Headers object, it returns null.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - Value of the retrieved header.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Headers/get"
      }}>{`Headers - get`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of the HTTP header.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="headers-has" id="headers-has"></a>
    <h2 {...{
      "id": "hasname"
    }}>{`has(name)`}</h2>
    <p>{`Indicates whether the Headers object contains a certain header.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{` - Indicates whether the Headers object contains the input name.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Headers/has"
      }}>{`Headers - has`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of the HTTP header.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="headers-set" id="headers-set"></a>
    <h2 {...{
      "id": "setname-value"
    }}>{`set(name, value)`}</h2>
    <p>{`Sets a new value for the existing header inside the Headers object, or add the header if it does not exist.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Headers/set"
      }}>{`Headers - set`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of the HTTP header.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Value of the HTTP header.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="headers-foreach" id="headers-foreach"></a>
    <h2 {...{
      "id": "foreachcallbackfn-thisarg"
    }}>{`forEach(callbackFn, thisArg)`}</h2>
    <p>{`Executes a callback function once per each key/value pair in the Headers object.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Headers/forEach"
      }}>{`Headers - forEach`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`callbackFn`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Function to execute for each entry in the map. It takes the following arguments.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`thisArg`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Value to use as this when executing callback.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="headers-keys" id="headers-keys"></a>
    <h2 {...{
      "id": "keys"
    }}>{`keys()`}</h2>
    <p>{`Returns an iterator object allowing to go through all keys contained in the Headers object.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`iterator`}</inlineCode>{` - Iterator.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Headers/keys"
      }}>{`Headers - keys`}</a>{`  `}</p>
    <a name="headers-values" id="headers-values"></a>
    <h2 {...{
      "id": "values"
    }}>{`values()`}</h2>
    <p>{`Returns an iterator object allowing to go through all values contained in the Headers object.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`iterator`}</inlineCode>{` - Iterator.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Headers/values"
      }}>{`Headers - values`}</a>{`  `}</p>
    <a name="headers-entries" id="headers-entries"></a>
    <h2 {...{
      "id": "entries"
    }}>{`entries()`}</h2>
    <p>{`Returns an iterator object allowing to go through all key/value pairs contained in the Headers object.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`iterator`}</inlineCode>{` - Iterator.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Headers/entries"
      }}>{`Headers - entries`}</a>{`  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      